
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94 94"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47","cy":"47","r":"47","fill":"#cad3e0"}}),_c('path',{attrs:{"d":"M75 21.9c.8-.4 1.7-.1 2.1.7v.1l2.2-.7.6-3.8-4.2-.7-.5-1.5c.6-.4.8-1.2.4-1.9-.4-.8-1.3-1.1-2.1-.7s-1.1 1.3-.7 2.1c0 .1.1.1.1.2l-.9 1.2-4.2-.7-.7 4.2-1.5.6c-.4-.7-1.3-.9-2-.6-.8.4-1.1 1.3-.7 2.1.4.8 1.3 1.1 2.1.7.1-.1.2-.1.3-.2l1.4 1-.7 4.3 4.4.7.9-1.2a1.53 1.53 0 01.4-2.5c.8-.4 1.7-.1 2.1.7.4.8.1 1.7-.7 2.1H73l.4 1.4 4.5.7.7-4.5-1.9-1.3c-.1.2-.3.3-.5.4-.8.4-1.7.1-2.1-.7-.2-.9.1-1.8.9-2.2zM62.7 52.4c.6-1.1 5.8-11.3 1.2-20.3-4.7-9.4-15.7-10.7-19.6-11.2-10-1.2-20.3 2.4-24 8.6-1.2 2-1.8 4.4-3 8.7-.2.6-.7 2.4-.6 3.8.1 2 1.8 2.3 2.1 3.9.3 1.8-.7 2.2-3.3 7.2-1.2 2.4-1.9 3.6-1.6 4.2.7 1.7 3.3 1.8 3.4 3 .1 1.1-1.7 2.2-1.4 3 .1.2.2.3.5.4l1.3.9-.7.6c-.3.2-.4.5-.4.6.1.3.6.7 1.3 1.1.6.3 1 .5 1.4 1.2.6 1-.3 1.8-.2 3.1.1.8.5 1.8 2 3 .4.3.9.4 1.4.3l8.5-2.4c.4-.1.8 0 1 .4l4.1 6.4c.2.3.5.5.9.5 7.9-.1 15.9-.1 23.8-.2.4 0 .6-.4.4-.7-3.5-6.9-5.4-14.2-2.6-20.2 1.4-2.6 2.4-2.8 4.1-5.9zm-7.3-9.2l-1.3-1.1.1-.1c.6-.9.3-2-.6-2.6-.9-.6-2.1-.3-2.6.6-.6.9-.3 2.1.6 2.6.1.1.3.2.5.2l-.2 1.8-4.9 2.1-2-4.6-2-.2c-.1.2-.1.3-.2.4-.6.9-1.7 1.1-2.6.6-.9-.6-1.1-1.7-.6-2.6.5-.8 1.6-1.1 2.4-.7l1.2-1.6-2-4.6 4.6-2 .1-1.9c-.1 0-.1-.1-.2-.1-.9-.6-1.1-1.7-.6-2.6.6-.9 1.7-1.1 2.6-.6.8.5 1.1 1.4.8 2.2l1.4 1.2 4.6-2 2.2 5-1.2 1.5c0-.1-.1-.1-.1-.1-.9-.6-2.1-.3-2.6.6-.6.9-.3 2 .6 2.6.9.6 2.1.3 2.6-.6.2-.2.3-.5.3-.7l1.9.1 2.2 5-5 2.2z","fill":"#fff"}})])
          )
        }
      }
    